var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListNumbered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.438 3.125H7.188v1.25h11.25zM18.438 9.375H7.188v1.25h11.25zM18.438 15.625H7.188v1.25h11.25zM4.688 6.25V1.563h-2.5v1.25h1.25V6.25zM2.188 10.239v1.948h3.125v-1.25H3.585l1.728-.863V7.5H2.188v1.25h1.874v.551zM2.188 17.188v1.25h3.125v-5H2.188v1.25h1.874v.624h-.937v1.25h.938v.625z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListNumbered);
export default ForwardRef;